"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var json_1 = require("../helpers/json");
var Coupon_1 = require("../../classes/Coupon");
var OrderDetailsService = /** @class */ (function () {
    function OrderDetailsService(UserService, $rootScope, CrmTasksModel, OrdersModel, PayPalService) {
        this.payment = {
            id: 0,
            charged_on: '',
            school_id: 0,
            user_id: 0,
            fee_id: 0,
            order_id: 0,
            amount: 0,
            charge_id: '',
            payment_method: '',
            notes: '',
            created_at: '',
            updated_at: '',
            deleted_at: '',
            void: false,
            check_number: ''
        };
        this.order = {
            id: '',
            paid: false,
            total: 0,
            student_id: 0,
            school_id: 0,
            organization_id: 0,
            status: '',
            source: '',
            notes: [],
            created_at: '',
            updated_at: '',
            deleted_at: '',
            created_by: {
                id: 0,
                firstname: '',
                lastname: '',
                email: '',
                status: '',
                usertype_id: 0,
                school_id: 0,
                username: '',
                fullname: '',
                usermeta: {}
            },
            coupons: [],
            lineitems: [],
        };
        this.currentUser = UserService.getCurrentUser();
        this.$rootScope = $rootScope;
        this.CrmTasksModel = CrmTasksModel;
        this.OrdersModel = OrdersModel;
        this.PayPalService = PayPalService;
        this.details = {};
        this.billingConfig = {
            gateway: '',
            gateway_config: {
                paypal_rest_api_client_id: ''
            },
            policyMeta: {
                id: ''
            }
        };
    }
    OrderDetailsService.prototype.submitPayment = function () {
        //use this.setPayment in component to set payment before calling this submit function
        if (this.billingConfig.gateway === 'paypal' && this.details.hasOwnProperty('id')) {
            this.payment.charge_id = this.details.id;
        }
        return this.OrdersModel.submitPayment({ 'order_id': this.payment.order_id, 'payment': this.payment });
    };
    OrderDetailsService.prototype.configureBilling = function (response) {
        var billingConfig = {
            policyMeta: {},
            gateway: '',
            gateway_config: {}
        };
        response.policy.policymeta.forEach(function (meta) {
            billingConfig.policyMeta[meta.meta_key] = meta.meta_value;
        });
        billingConfig.policyMeta.id = response.policy.id;
        billingConfig.gateway = billingConfig.policyMeta.billing_gateway;
        billingConfig.gateway_config = {
            paypal_rest_api_client_id: billingConfig.policyMeta.paypal_rest_api_client_id
        };
        this.setBillingConfig(billingConfig);
        return billingConfig;
    };
    OrderDetailsService.prototype.setupOrderDetails = function (response, payment) {
        var order = response.data.order;
        order.student = payment.student;
        order.payments = response.data.payments;
        order.lineitems = order.lineitems.map(function (lineitem) {
            // @ts-ignore
            lineitem.product_details = (0, json_1.isJson)(lineitem.product_details) ? JSON.parse(lineitem.product_details) : lineitem.product_details;
            return lineitem;
        });
        var coupons = [].concat(order.coupons).map(function (coupon) {
            return new Coupon_1.Coupon(coupon);
        });
        order.created_at = (0, moment_1.default)(order.created_at).format('MM/DD/YYYY h:mm a');
        // @ts-ignore
        order.coupons = coupons;
        this.setOrder(order);
        return order;
    };
    OrderDetailsService.prototype.setOrder = function (data) {
        this.order = data;
    };
    OrderDetailsService.prototype.clearOrder = function () {
        this.order = {
            id: '',
            paid: false,
            total: 0,
            student_id: 0,
            school_id: 0,
            organization_id: 0,
            status: '',
            source: '',
            created_at: '',
            updated_at: '',
            deleted_at: '',
            created_by: {
                id: 0,
                firstname: '',
                lastname: '',
                email: '',
                status: '',
                usertype_id: 0,
                school_id: 0,
                username: '',
                fullname: '',
                usermeta: {}
            },
            coupons: [],
            lineitems: [],
            notes: []
        };
    };
    OrderDetailsService.prototype.getOrder = function () {
        return this.order;
    };
    OrderDetailsService.prototype.setPayment = function (data) {
        this.payment = data;
    };
    OrderDetailsService.prototype.clearPayment = function () {
        this.payment = {
            id: 0,
            charged_on: '',
            school_id: 0,
            user_id: 0,
            fee_id: 0,
            order_id: 0,
            amount: 0,
            charge_id: '',
            payment_method: '',
            notes: '',
            created_at: '',
            updated_at: '',
            deleted_at: '',
            void: false,
            check_number: ''
        };
    };
    OrderDetailsService.prototype.getPayment = function () {
        return this.payment;
    };
    OrderDetailsService.prototype.setPayPalDetails = function (details) {
        this.details = details;
    };
    OrderDetailsService.prototype.getPayPalDetails = function () {
        return this.details;
    };
    OrderDetailsService.prototype.handlePayPalPayment = function (details) {
        // console.log('PaPal Payment Details: ', details)
        // this.setPayPalDetails(details) //save details
        // this.submitPayment(payment);
    };
    OrderDetailsService.prototype.setBillingConfig = function (config) {
        this.billingConfig = config;
    };
    return OrderDetailsService;
}());
OrderDetailsService.$inject = ['UserService', '$rootScope', 'CrmTasksModel', 'OrdersModel', 'PayPalService'];
exports.default = OrderDetailsService;
